import { render, staticRenderFns } from "./BiddingRequestDetermination.vue?vue&type=template&id=4994895e"
import script from "./BiddingRequestDetermination.vue?vue&type=script&lang=js"
export * from "./BiddingRequestDetermination.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports